@if (categoryGroupList()) {
    <div class="cipo--height--full" cdkDropListGroup>
        <cipo-horizontal-splitter [leftPaneOptions]="horizontalSplitterOptions()">
            <div leftContent class="cipo--height--full">
                <cipo-nested-list
                    class="cipo--height--full"
                    #mainList
                    connectedListTo="otherCategoriesList"
                    [rowActions]="rowActions()"
                    [topActions]="topActions()"
                    [(list)]="categoryGroupList"
                    [(anythingChanged)]="anythingChanged"
                    (addNewAction)="addNewCategory()"
                    (dropOtherList)="handleDropOtherList($event)">
                    <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                        <button mat-icon-button (click)="goBack()" [attr.aria-label]="'a11y.common.back' | translate">
                            <mat-icon class="material-symbols-outlined" aria-hidden="true">arrow_back</mat-icon>
                        </button>
                        <cipo-text class="name-control" [control]="nameControl"></cipo-text>
                    </div>
                </cipo-nested-list>
            </div>
            @if (otherCategories()) {
                <div rightContent class="cipo--height--full">
                    <cipo-nested-list
                        class="cipo--height--full"
                        #otherCategoriesList
                        connectedListTo="mainList"
                        [rowActions]="rowActionsOther()"
                        [options]="otherCategoriesOptions()"
                        [list]="otherCategoriesArray()"
                        (dropOtherList)="handleDropOtherList($event)">
                        <cipo-select class="periods-select" [control]="groupControl" [fieldData]="groupControlData()" />
                    </cipo-nested-list>
                </div>
            }
        </cipo-horizontal-splitter>
    </div>
}
